import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../constants/common'
import i18n from '../../../i18n'
import { formValidationSchemaNoChanged } from '../../Form'

import {
  EMAIL_ADD_NOTE_FIELD_MAX_LENGTH,
  EMAIL_ADD_NOTE_FIELD_NAME_NOTE,
} from './EmailAddNoteActionModal.constants'

export function getEmailAddNoteValidationSchema(initialValues) {
  return Yup.object({
    [EMAIL_ADD_NOTE_FIELD_NAME_NOTE]: Yup.string()
      .max(
        EMAIL_ADD_NOTE_FIELD_MAX_LENGTH,
        i18n.t('Error.MaxLengthKey', {
          length: EMAIL_ADD_NOTE_FIELD_MAX_LENGTH,
        })
      )
      .ensure(),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
    })
  )
}

export function getEmailAddNoteInitialValues(value) {
  return {
    [EMAIL_ADD_NOTE_FIELD_NAME_NOTE]: value || EMPTY_STRING,
  }
}
